import React from "react";
import GrowthPartnerCourseCard from "components/CourseBuilder/GrowthPartnerCourseCard/GrowthPartnerCourseCard";
import { useTeamContext } from "store/contexts/teamContext";
import Loader from "components/Loader";

const GrowthPartnerCourseLists = ({ courses, total, isLoading }) => {
  const { team } = useTeamContext();
  
  const noCourses = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "100px 0",
  };

  return (
    <div className="courses-cards">
      <div className="row courseRow">
        {courses.map((course, index) => (
          <GrowthPartnerCourseCard 
            key={course.id} 
            course={course} 
            index={index} 
            teamId={team?.id}
          />
        ))}
      </div>
      {isLoading && <div style={loaderStyle}><Loader /></div>}
      {!isLoading && (courses.length === 0 || total === 0) && (
        <div style={noCourses}>You don't have any courses as a growth partner</div>
      )}
    </div>
  );
};

export default GrowthPartnerCourseLists; 